import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { mergeSearch, readSearchParams } from '../utils/urlParams';

// Состояние навигации (проект, кабинет, вкладка, подвкладка) живёт в адресе: F5, ссылка и кнопка
// «Назад» работают одинаково. Один хук вместо пар эффектов «состояние → адрес» и «адрес → состояние».
//
// update({ ключ: значение }) — меняет параметры адреса; пустое значение (''/null/undefined) удаляет параметр.
//   push: true  — новая запись в истории (осмысленный переход: проект, кабинет, вкладка);
//   push: false — замена текущей записи (уточнение: значения по умолчанию, поиск).
// Адрес читается «вживую» (window.location): pushState синхронный, поэтому несколько update подряд
// в одном обработчике не затирают друг друга.
export { readSearchParams, mergeSearch };

export function useUrlParams() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const get = useCallback((key) => params.get(key) || '', [params]);

  const update = useCallback((patch, { push = false } = {}) => {
    const { search, changed } = mergeSearch(window.location.search, patch);
    if (!changed) return;
    navigate({ pathname: window.location.pathname, search }, { replace: !push });
  }, [navigate]);

  return { params, get, update };
}
